import { Checkbox, Select } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
// import { ReactComponent as AddSvg } from '../../assets/svg/add.svg';
import BorderBox from '../BorderBox/index.jsx';
import { ReactComponent as ArrowRightSvg } from '../../assets/svg/arrow-right.svg';
import { TableBoxView } from '../GenerateLayout/index.jsx';
import { useRoot } from '../../hooks/useRoot.jsx';
import { ReactComponent as EmptyDataSvg } from '../../assets/svg/empty-data.svg';
import { addNewLayout, addNewProject } from '../../api/request.js';
import { PCROWCOL } from '../../utils/utils.ts';

const numAry = [1,2,3,4,5,6,7,8,9,10];
const GenerateTable = () => {
  const { setRowCol, setStep, setCurProId, setCurLayoutId, rowCol } = useRoot();
  const [colNum, setColNum] = useState(5);
  const [rowNum, setRowNum] = useState(4);
  const [isShare, setIsShare] = useState(true);

  const fnGenerate = useCallback(() => {
    setRowCol({
      row: rowNum,
      col: colNum
    });
  }, [rowNum, colNum]);

  useEffect(() => {
    if(rowCol.row === 0 && rowCol.col === 0) {
      fnGenerate();
    }
  }, [fnGenerate, rowCol]);

  const fnCreateProjectAndLayout = async () => {
    try {
      const userInfo = JSON.parse(sessionStorage.getItem('user') || '{}');
      const result = await addNewProject({username: userInfo.username});
      if(result.status === 'Success') {
        setCurProId(result.data.projectid);
        const params = {
          projectid: result.data.projectid,
          columns: colNum,
          rows: rowNum,
          is_share: isShare
        };
        const layoutResult = await addNewLayout(params);
        if(layoutResult.status === 'Success') {
          sessionStorage.setItem(PCROWCOL, JSON.stringify(rowCol));
          setCurLayoutId(layoutResult.data.layoutid);
          setStep(2);
        }
      }
    } catch(error) {
      //
    }
  };

  const fnCheckChange = (e) => {
    setIsShare(e.target.checked);
  };

  return <div className="flex-1 bg-[#00000099] flex flex-col justify-start">
    <div className='bg-[#00A32E] h-[45px] leading-[45px] px-[30px] text-base font-bold'>
        Please define your shelf dimensions:
    </div>
    <div className='flex-1 pt-3 px-[20px] pb-[10px] flex flex-col'>
      <div className='bg-[#02290C] rounded-[10px] p-3 flex justify-start items-center mb-2'>
        <div className='w-[200px]'>
          <div className='text-sm text-[#FFFFFF80] font-bold mb-2'>Number of Row:</div>
          <Select
            className='w-full'
            options={numAry.map(item => ({ value: item, label: item }))}
            value={rowNum}
            onChange={(e) => setRowNum(e)}
          >
          </Select>
        </div>

        <div className='w-[200px] ml-5'>
          <div className='text-sm text-[#FFFFFF80] font-bold mb-2'>Number of Column:</div>
          <Select
            className='w-full'
            options={numAry.map(item => ({ value: item, label: item }))}
            value={colNum}
            onChange={(e) => setColNum(e)}
          >
          </Select>
        </div>
        <div className='flex-1'></div>
        <div>
          <div className='text-sm text-transparent font-bold w-fit'>placeholder</div>
          <div onClick={fnGenerate} className='border-2 border-[#26F028] text-[#26F028] rounded-[23px] px-[50px] w-fit h-[38px] flex justify-center items-center cursor-pointer'>
            Generate Preview
          </div>
        </div>
      </div>

      <BorderBox className='flex-1 flex justify-center items-center p-5 relative'>
        {
          rowCol.col > 0 && rowCol.row > 0 ? <TableBoxView isPre={true} ref={null}></TableBoxView> :
            <div className='flex flex-col justify-center items-center text-[20px] font-bold text-[#00A32E]'>
              <EmptyDataSvg></EmptyDataSvg>
              <span className='mt-[20px]'>Please enter the data above and</span>
              <span>generate a preview</span>
            </div>
        }

        <div className='flex items-baseline justify-start w-[180px] absolute bottom-5 right-3'>
          <Checkbox checked={isShare} onChange={fnCheckChange}></Checkbox>
          <div className='text-[10px] text-[#848484] ml-2'>
            Publish my testing results in the Sous-Chef library (visible for others). Deselect it for keeping results only visible to you
          </div>
        </div>
      </BorderBox>
    </div>

    <div className='flex justify-end mb-2 px-[30px]'>
      <div onClick={fnCreateProjectAndLayout} className='bg-btn flex justify-center items-center'>
        <span className='text-lg font-bold leading-none mr-4'>NEXT</span>
        <ArrowRightSvg className="w-5 mt-1"></ArrowRightSvg>
      </div>
    </div>
  </div>;
};

export default GenerateTable;